import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGuideToggleStatus } from "../../../redux/slices/statistics/statisticSlice";

function ToggleDetails() {
  const dispatch = useDispatch();
  const Status = useSelector((state) => state.statistics.GuideStatsToggleStatus);

  return (
    <div className="flex items-center justify-center w-full mt-8 mb-6">
      <label htmlFor="toggleB" className="flex items-center ">
        <div className="relative">
          <input id="toggleB" className="sr-only" />
            <div className="block bg-cyan-100 w-96 h-10 rounded-full">
              <div className="flex flex-row justify-evenly pt-3">
                <p
                  onClick={() => dispatch(setGuideToggleStatus("Info"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                 Info
                </p>
                <p
                  onClick={() => dispatch(setGuideToggleStatus("Step Flow"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                 Step Flow
                </p>
                <p
                  onClick={() => dispatch(setGuideToggleStatus("Transaction"))}
                  className="text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  Transaction
                </p>
              </div>
            </div>
              {Status === "Info" ? (
                <div className="absolute left-8 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Info
                </div>
              ) : null}
              {Status === "Step Flow" ? (
                <div className="absolute left-36 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Step Flow
                </div>
              ) : null}
              {Status === "Transaction" ? (
                <div className="absolute left-64 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Transaction
                </div>
              ) : null}
        </div>
      </label>
    </div>
  );
}

export default ToggleDetails;
